import React from 'react';
import { Box } from '@mui/material';
import { DModal, DPageLoader } from '../../../../../dum';
import { OrderSaleIcon } from '../../../../icons';
import { OrderSaleDetailsChangeForm } from './order-sale-details-change-form';
import { useOrderSaleDialogQuery } from '../../../../../../services';

interface ISUpdateOrderSaleDetailsDialogProps {
    open: boolean;
    setOpen: (open: boolean) => void;
    orderSaleId: number | null;
}

export function SUpdateOrderSaleDetailsDialog({
    open,
    setOpen,
    orderSaleId,
}: ISUpdateOrderSaleDetailsDialogProps) {
    // Fetches fresh by id rather than reusing the row object the list already
    // had in memory — otherwise this dialog can reopen with whatever the list
    // last fetched, which goes stale the moment the list itself doesn't
    // refetch in between edits.
    const { data, loading } = useOrderSaleDialogQuery({
        skip: !orderSaleId || !open,
        variables: {
            OrderSaleId: orderSaleId!,
        },
    });

    const orderSale =
        orderSaleId && data && data.getOrderSale && open
            ? data.getOrderSale
            : undefined;

    return (
        <DModal
            icon={<OrderSaleIcon />}
            title={'Editar datos opcionales'}
            open={open}
            setOpen={setOpen}
        >
            {loading ? (
                <DPageLoader />
            ) : orderSaleId ? (
                <Box sx={{ p: 2 }}>
                    <OrderSaleDetailsChangeForm
                        orderSaleId={orderSaleId}
                        currentNotes={orderSale?.notes}
                        currentExpectedPaymentDate={
                            orderSale?.expected_payment_date
                        }
                        currentRequireSupplement={
                            orderSale?.require_supplement
                        }
                        currentSupplementCode={orderSale?.supplement_code}
                        currentRequireCreditNote={
                            orderSale?.require_credit_note
                        }
                        currentCreditNoteCode={orderSale?.credit_note_code}
                        currentCreditNoteAmount={orderSale?.credit_note_amount}
                        currentCanceled={orderSale?.canceled}
                        subtotal={orderSale?.subtotal}
                        tax={orderSale?.tax}
                        totalWithTax={orderSale?.total_with_tax}
                        realPaymentsTotal={
                            orderSale?.transfer_receipts_total_no_adjustments
                        }
                        onSuccess={() => setOpen(false)}
                    />
                </Box>
            ) : null}
        </DModal>
    );
}
